export const PERSON_ROLES = {
  CLIENT: 'CLIENT',
  EMPLOYEE: 'EMPLOYEE',
} as const;

/**
 * Phrase type enum per OpenAPI PhraseTypeEnum
 *
 * Типы событий в диалоге, которые могут приходить в ответе GET /conversation/{id}/transcript:
 *
 * - `PHRASE` - фраза диалога (основной тип события)
 *   Обязательные поля: `person`, `finishedAt`
 *   Опциональные поля: `text`, `angry`, `sad`, `neutral`, `positive` (если прошла обработка LLM на определение эмоций)
 *
 * - `INTERRUPTION` - сведения о прерывании в диалоге (когда один участник прерывает другого)
 *   Обязательные поля: `finishedAt`, `interruptedPhraseId`, `interruptionPhraseId`
 *
 * - `PAUSE` - сведения о паузах в диалоге
 *   Обязательные поля: `personId`, `finishedAt`
 *
 * - `STOP_WORD` - сведения о стоп-словах, которые встретились в диалоге
 *   Обязательные поля: `stopWordId`, `person`, `stopWordPhraseId`
 */
export const PHRASE_TYPES = {
  /** Фраза диалога - основной тип события, содержащий текст и информацию о говорящем */
  PHRASE: 'PHRASE',
  /** Прерывание в диалоге - когда один участник прерывает речь другого */
  INTERRUPTION: 'INTERRUPTION',
  /** Пауза в диалоге - пауза в речи участника */
  PAUSE: 'PAUSE',
  /** Стоп-слово - обнаруженное стоп-слово в тексте фразы */
  STOP_WORD: 'STOP_WORD',
} as const;
